import React, { Component }         from 'react';
import GoogleMap                    from '../GoogleMap.js';
import MetaCartaMap                 from '../MetaCartaMap';
import IPUtils                      from '../../../utils/ipv4Utils';

class IPv4View extends Component{
    constructor(props){
        super(props);

        this.metadata = this.metadata.bind(this);

        this.state = {
            expanded: false
        }

        this.mapDisable = window._mapDisable;
        this.mapMetaCartaUrl = window._mapMetaCartaUrl;
    }

    metadata () {
        var coords = IPUtils.getIpCoordinates(this.props.entity);
        return (
            <div className="ip-wrapper">
                <p hidden={!coords}>
                    Coordinates : {coords}
                </p>
                {('salienceScore' in this.props && this.props.salienceScore != null) &&
                    <p>
                        {this.props.salienceScore.toFixed(4)}
                    </p>
                }
            </div>
        );
    }

    sentiment () {
        let sentimentClassName;
        if (this.props.overallSentiment) {
            if (this.props.overallSentiment.class === 'positive') {
                sentimentClassName = 'detailed-sentiment-positive';
            } else if (this.props.overallSentiment.class === 'neutral') {
                sentimentClassName = 'detailed-sentiment-neutral';
            } else if (this.props.overallSentiment.class === 'negative') {
                sentimentClassName = 'detailed-sentiment-negative';
            }
        }
        return (
            <div className={ 'detailed-sentiment-wrapper ' + sentimentClassName }>
                {(this.props.overallSentiment.score !== undefined) &&
                    <div>
                        <span className="fa fa-angle-double-right"/>Score : {this.props.overallSentiment.score}
                    </div>
                }
                <div>
                    <span className="fa fa-angle-double-right"/>Class : {this.props.overallSentiment.class}
                </div>
                <div>
                    <span className="fa fa-angle-double-right"/>Confidence : {this.props.overallSentiment.classConfidence}
                </div>
            </div>
        );
    }

    render () {
        var ipRegion = IPUtils.getIpRegion(this.props.entity);
        var cardMapSize = {width: 100 + '%', height: 350 + 'px'};
        var lat = IPUtils.getIpLatitude(this.props.entity);
        var lon = IPUtils.getIpLongitude(this.props.entity);
        var title = this.props.entity.normalizedText;

        return (
            <div>
                <div>
                    <h3 className="details-title">
                        {title} <span hidden={!ipRegion} className="details-region">({ipRegion})</span>
                    </h3>
                    {(lat && lon) &&
                        <div className='details-card'>
                            <div className="map" hidden={ this.mapDisable }>
                                {this.mapMetaCartaUrl ? 
                                    <MetaCartaMap className="map-container" 
                                        style={cardMapSize} 
                                        label={title} 
                                        lat={ lat } 
                                        lng={ lon } 
                                        type={this.props.entity.type}/>
                                    :
                                    <GoogleMap style={cardMapSize} 
                                        label={title} 
                                        lat={ lat } 
                                        lng={ lon } 
                                        type={this.props.entity.type}/>
                                }
                            </div>
                            {this.props.overallSentiment &&
                                this.sentiment()
                            }
                            <div className='result-json expanded'>
                                <div className='description'>
                                    <div>
                                        { this.metadata() }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
};

export default IPv4View;
